/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { 
    Card, CardBody,  Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
  } from 'reactstrap';
import { Link } from 'react-router-dom';
import CountyTable from './components/CountyTable'
import States from './components/states';
import ChangePassword from '@/components/ChangePassword';
import ApiServices from "@/utils/ApiServices";
import { successMsg, globalError } from "../../utils/message_herlper"
import TitleBreadCrumbs from '@/components/TitleBreadCrumbs'
import { TABLE_SETTINGS } from "@/utils/constant";
import './county-style.css';

const CountyList = () => {

    const [isSubmit, setSubmit] = useState(false);
    const [id, setID] = useState('');
    const [changePass, setChangePass] = useState(false);

    const openChangePass  = (id) => {
        setID(id)
        setChangePass(true)
    }

    const onChangePassword  = (form) => {
        setSubmit(true)
        form.id = id
        ApiServices.updatePassword(form).then((result) => {  
           setTimeout(() =>{
               setChangePass(false)
               setSubmit(false)
               successMsg('PASSWORD_SUCCESS');
           },1000)
        })
        .catch((error) => {
            setSubmit(false)
            globalError()
        })
    }


    return (
        <>
        <ChangePassword isSubmit={isSubmit}   open={changePass}  onSubmit={(form) => onChangePassword(form)}  close={() => setChangePass(false)}  />
        <Container>
            <TitleBreadCrumbs title="List of Counties"  link="/county-form/create" btn="Create County" >
                <div className="page-breadcrumbs">
                    <Link to="/">Dashboard</Link>
                    <Link to="/settings">Settings</Link>
                    <span className="current_breadcrumbs">
                        County List
                    </span>
                </div>
            </TitleBreadCrumbs>
            {/* <States /> */}
            <Card className="card-controlled">
                <CardBody className="cardbody-controlled">
                    <div className="">
                        <CountyTable  />
                    </div>
                </CardBody>
            </Card>
        </Container>
        </>
    );
}

export default CountyList;